/**
 * document.execCommand方式
 */
export const execCommandClip = (value: string) => {
  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);
  // 隐藏此输入框
  textarea.style.position = 'fixed';
  textarea.style.clip = 'rect(0 0 0 0)';
  textarea.style.top = '10px';
  textarea.value = value;
  textarea.select();
  const isSuc = document.execCommand('copy', true);
  document.body.removeChild(textarea);
  return isSuc;
};
